import { render } from "./SportLiveMatches.vue?vue&type=template&id=1139e399&scoped=true"
import script from "./SportLiveMatches.vue?vue&type=script&lang=js"
export * from "./SportLiveMatches.vue?vue&type=script&lang=js"

import "./SportLiveMatches.vue?vue&type=style&index=0&id=1139e399&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1139e399"]])

export default __exports__